import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RANGE_SPLITTER } from '~/constants/ModelConstants';
import * as searchActions from '~/search2/actions';
import Tooltip from 'rc-tooltip';
import Slider, { Range } from 'rc-slider';
import CvssService from '~/utils/CvssService';
const Handle = Slider.Handle;
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
const isCvss3Enabled = CvssService.isCvss3Enabled();
type CSSeverityFilterProps = {
  actions: object;
  searchDataState: object;
};
class CSSeverityFilter extends React.Component<CSSeverityFilterProps, {}> {
  componentDidUpdate(prevProps) {
    const { filters: currentFilter = {} } = this.props.searchDataState;
    const { filters: oldFilters = {} } = prevProps.searchDataState;
    // Update the component with severity for first load
    if (!oldFilters.severity && currentFilter.severity) {
      this.parseAndUpdateSeverityVal(currentFilter.severity);
    }
    // Reset severity val when user selected type:library
    if (_.includes(oldFilters.type, 'vulnerability') && _.includes(currentFilter.type, 'library')) {
      this.handleSliderSeverityChange([0, 10]);
    }
    // When user manually update the text in the search, update severity
    if (oldFilters.severity !== currentFilter.severity) {
      this.parseAndUpdateSeverityVal(currentFilter.severity);
    }
  }
  isRangeVal(val) {
    let validRange = false;
    if (val.length > 0 && val.includes(RANGE_SPLITTER)) {
      validRange =
        val
          .split(RANGE_SPLITTER)
          .map(item => parseFloat(item))
          .filter(item => isNaN(item)).length == 0;
    }
    return validRange;
  }
  isSingleVal(val) {
    let validSingleVal = false;
    if (val.length > 0 && !val.includes(RANGE_SPLITTER)) {
      validSingleVal = isNaN(parseFloat(val)) === false;
    }
    return validSingleVal;
  }
  parseAndUpdateSeverityVal(val) {
    if (this.isRangeVal(val)) {
      const sliderVal = val.split(RANGE_SPLITTER).map(val => parseFloat(val));
      this.handleSliderSeverityChange(sliderVal);
    } else if (this.isSingleVal(val)) {
      this.handleSliderSeverityChange([val, 10]);
    } else {
      // Invalid severity
      this.handleSliderSeverityChange([0, 10]);
    }
  }
  updateSeverityFilter = val => {
    const concatenatedVal = val.reduce((prev, curr) => prev + RANGE_SPLITTER + curr);
    if (!isCvss3Enabled) {
      this.props.actions.setFilter('severity', concatenatedVal);
    } else {
      const { searchDataState = {} } = this.props;
      const isCvss3Selected = searchDataState.cvss === 'cvss3';
      const severityKey = isCvss3Selected ? 'cvss3_severity' : 'cvss2_severity';
      this.props.actions.setFilter(severityKey, concatenatedVal);
    }
  };
  handle(props) {
    const { value, dragging, index, ...restProps } = props;
    return (
      <Tooltip
        overlay={value}
        overlayStyle={{ width: 35 }}
        visible={dragging}
        placement="bottom"
        key={index}
        destroyTooltipOnHide={true}
      >
        <Handle {...restProps} />
      </Tooltip>
    );
  }
  handleSliderSeverityChange = val => {
    this.props.actions.updateSeverityVal(val);
  };
  handleOnClick() {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }
  }
  render() {
    const { filters = {}, severityVal, cvss = 'cvss2' } = this.props.searchDataState;
    const filterTypeUsed = type => filters.type && filters.type.indexOf(type) !== -1;
    let disabled = false;
    // if they only want to see library records then disable vuln only fields
    if (filterTypeUsed('library')) {
      disabled = true;
    }
    let marks = {
      0: { label: <strong className="color--warning">0</strong> },
      4: { label: <strong className="color--warning">4</strong> },
      7: { label: <strong className="color--danger">7</strong> },
      10: { label: <strong className="color--danger">10</strong> },
    };
    // If cvss3 is selected, add in another color seperator for score 9 and 10 due
    // to "critical" level. We are using hash coded color as
    if (cvss === 'cvss3') {
      marks = {
        ...marks,
        9: { label: <strong className="color--danger-dark">9</strong> },
        10: { label: <strong className="color--danger-dark">10</strong> },
      };
    }
    const SEVERITY_SLIDER_PROPS = {
      min: 0,
      max: 10,
      step: 0.1,
      marks,
    };
    const severitySliderWrapperStyle = {
      width: 150,
      marginTop: 10,
      marginBottom: 20,
    };
    return (
      <div style={severitySliderWrapperStyle} onClick={this.handleOnClick}>
        <Range
          min={SEVERITY_SLIDER_PROPS.min}
          marks={SEVERITY_SLIDER_PROPS.marks}
          step={SEVERITY_SLIDER_PROPS.step}
          max={SEVERITY_SLIDER_PROPS.max}
          onChange={this.handleSliderSeverityChange}
          onAfterChange={val => this.updateSeverityFilter(val)}
          handle={this.handle}
          disabled={disabled}
          value={severityVal}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSSeverityFilter);
